import { useQuery } from "@tanstack/react-query";
import { fetchGamificationBattle } from "../services/gamificationService";

function normalizeBattleItem(item, index) {
  return {
    id: Number(item?.battles_id || index + 1),
    title: item?.battles_name || "Battle",
    description: item?.battles_description || "",
    image: item?.battles_image || "",
    logo: item?.brand_logo || "",
    raw: item,
  };
}

export function useGamificationBattle(options = {}) {
  return useQuery({
    queryKey: ["gamificationBattle"],
    queryFn: async () => {
      const { payload } = await fetchGamificationBattle();
      const battles = Array.isArray(payload?.battles_list) ? payload.battles_list : [];

      return {
        userCoins: Number(payload?.user_coins || 0),
        rank: Number(payload?.rank || 0),
        score: Number(payload?.score || 0),
        battles: battles.map((item, index) => normalizeBattleItem(item, index)),
      };
    },
    enabled: options.enabled ?? true,
    staleTime: 0,
    gcTime: 10 * 60 * 1000,
    retry: 2,
    refetchOnWindowFocus: false,
    refetchOnMount: "always",
    refetchOnReconnect: true,
    placeholderData: (previousData) =>
      previousData ?? {
        userCoins: 0,
        rank: 0,
        score: 0,
        battles: [],
      },
  });
}
